import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-class-down",
  "use": "icon-class-down-usage",
  "viewBox": "0 0 1797 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1797 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-class-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M1040.54710788 962.528125L1751.26801588 237.812125a139.533157 139.533157 0 0 0-97.025676-237.812125L135.56596588 0a139.533157 139.533157 0 0 0-96.50347099 237.498802L749.78340288 962.214802A202.302189 202.302189 0 0 0 1040.54710788 962.528125z\" p-id=\"4395\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol